import axios, { AxiosInstance } from 'axios';
import type { User } from 'oidc-client-ts';

const apiBase = import.meta.env.VITE_API_BASE || 'http://voice.test/api/v1';

export function buildApiClient(getUser: () => User | null | undefined, getTenantCode: () => string | null, getWarehouseCode: () => string | null): AxiosInstance {
  const c = axios.create({ baseURL: apiBase, timeout: 10000 });
  c.interceptors.request.use((config) => {
    const user = getUser();
    if (user?.access_token) {
      config.headers.Authorization = `Bearer ${user.access_token}`;
    }
    const tenant = getTenantCode();
    if (tenant) config.headers['X-Tenant-Id'] = tenant;
    const wh = getWarehouseCode();
    if (wh) config.headers['X-Warehouse-Id'] = wh;
    return config;
  });
  return c;
}
